import React from 'react';
import { Route } from 'react-router-dom';

const HRDDashboard = React.lazy(() => import('../pages/hrd/HRDDashboard'));
const EmployeeManagement = React.lazy(() => import('../pages/hrd/EmployeeManagement'));
const AttendanceSchedule = React.lazy(() => import('../pages/hrd/AttendanceSchedule'));
const PayrollBenefits = React.lazy(() => import('../pages/hrd/PayrollBenefits'));
const PerformanceEvaluation = React.lazy(() => import('../pages/hrd/PerformanceEvaluation'));
const RecruitmentOnboarding = React.lazy(() => import('../pages/hrd/RecruitmentOnboarding'));
const LeaveManagement = React.lazy(() => import('../pages/hrd/LeaveManagement'));
const DisciplineManagement = React.lazy(() => import('../pages/hrd/DisciplineManagement'));
const TrainingCertification = React.lazy(() => import('../pages/hrd/TrainingCertification'));
const MedicalFeeSettings = React.lazy(() => import('../pages/hrd/medical-fee/MedicalFeeSettings'));
const PositionManagement = React.lazy(() => import('../pages/hrd/positions/PositionManagement'));

export const getHrdRoutes = () => [
  <Route key="hrd-dashboard" path="/hrd" element={<HRDDashboard />} />,
  <Route key="hrd-employees" path="/hrd/employees" element={<EmployeeManagement />} />,
  <Route key="hrd-positions" path="/hrd/positions" element={<PositionManagement />} />,
  <Route key="hrd-attendance" path="/hrd/attendance" element={<AttendanceSchedule />} />,
  <Route key="hrd-payroll" path="/hrd/payroll" element={<PayrollBenefits />} />,
  <Route key="hrd-performance" path="/hrd/performance" element={<PerformanceEvaluation />} />,
  <Route key="hrd-recruitment" path="/hrd/recruitment" element={<RecruitmentOnboarding />} />,
  <Route key="hrd-leave" path="/hrd/leave" element={<LeaveManagement />} />,
  <Route key="hrd-discipline" path="/hrd/discipline" element={<DisciplineManagement />} />,
  <Route key="hrd-training" path="/hrd/training" element={<TrainingCertification />} />,
  <Route key="hrd-medical-fee" path="/hrd/medical-fee" element={<MedicalFeeSettings />} />
];
